//moment(new Date()).format("Do MMMM")
export const signUpAction = (data, userId) => {
    return (dispatch, getState, { getFirebase }) => {
      const firestore = getFirebase().firestore();
      //console.log(data);
      firestore
        .collection("students")
        .doc(userId)
        .set(
          data
        )
        .then(() => {
          dispatch({
            type: "SIGN_UP",
            success: true
          });
        })
        .catch((err) => {
          dispatch({
            type: "SIGN_UP_ERR",
            err
          });
        });
    };
  };
  